import { TOGGLE_SIDEBAR, SET_SIDEBAR_SELECTED } from '../actions/actionTypes'

const initState = {
    isOpen : true,
    sideBarSelected : true
}

const navbarReducer = (state = initState, action) => {
    // console.log(action.info)
    switch(action.type){
        case TOGGLE_SIDEBAR : return {
            ...state,
            isOpen : !state.isOpen
        }
        case SET_SIDEBAR_SELECTED : return {
            ...state,
            sideBarSelected : action.value
        }
        default : return state
    }
};

export default navbarReducer;